import React from 'react'
import useFetch from '../../Services/useFetch'
import { useHistory } from 'react-router-dom';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tabs';
import { Button, Container, Row, Col } from 'reactstrap';
import { endpoints, roles } from '../../utils/Constants';
import { FormGroup,  Input } from 'reactstrap'; 
import { useState } from 'react';
import Editor from '../Models/Editor';
import { useEffect } from 'react';
import { FormLabel } from '../Form/FormLabel';
import { useAlert } from '../../Services/AlertContext';
import LoadingAnimation from '../Form/LoadingAnimation';
import entities from '../../utils/entities';
import useFetchSimple from '../../Services/useFetchSimple';





const ManageEntities = ({route, entity,id,allEntities }) => {
    let history = useHistory();
    const fetch = useFetchSimple();
    const [actions, loading, error,refreshActions] = useFetch(entity ? endpoints.getActionsForEntity + entity : null);
    const [statuses, loadings, errors, refreshStatus] = useFetch(entity ? endpoints.getStatusForEntity + entity : null);
    const [changeEvents, loadingsc, errorsc, refreshStatusChangeEvents] = useFetch(entity ? endpoints.getStatusChangeEventsForEntity + entity : null);
    const [newItem, setNewItem] = useState();
    const [newStateChangeEvent, setNewStateChangeEvent] = useState();
    const [stateChanges, setStateChanges] = useState([]);
    const [stateChangeItemId, setStateChangeItemId] = useState();
    const alert = useAlert();
    useEffect(() => {
        const requestedTab = allEntities?.find(x => x === entity);
        if (!requestedTab && allEntities) {
           // history.push(route + '/' + entities[0]);
        }
    }, [allEntities, entity,route]);
    useEffect(() => {
        if (actions) {
            const stateFromNames = actions.map(a => a.entityState);
            const stateFrom = stateFromNames.filter((value, index, self) => {
                return self.indexOf(value) === index;
            });

            const stateFromTo = stateFrom.map((x) => {
                const act = actions.filter(y => y.entityState === x);

                return {
                    stateFrom: x, stateTo: act.map(x => x.nextState).filter((value, index, self) => {
                        return self.indexOf(value) === index;
                    }) };
            })
            setStateChanges(stateFromTo);
        }
    },[actions])
    const setActiveSubTab = (tab) => {
        if ( entity !== tab) {
                history.push(route +'/'+ tab);
        }
    }
    const Checkbox = ({ checked, role, statusSetting }) => {
        const [loading, setLoading] = useState(false)
        const handleChange = (e) => {
            setLoading(true)
            let newStatus   = { ...statusSetting };
            newStatus['canEdit' + role] = e.currentTarget.checked;
            fetch(endpoints.updateValidStatus, { method: 'POST', body: JSON.stringify(newStatus) }).then((result) => {
                refreshStatus();
                setLoading(false)
            }, (error) => {
                    alert({ title: "Submit failed!", body: JSON.stringify(error) })
                    setLoading(false)
            })
        }
        return <FormGroup size='sm' check inline>
            <FormLabel check htmlFor={role} style={{ display: 'block' }}>
               {loading || loadings ?'...': < Input id={role} name={role} type='checkbox' onChange={handleChange} checked={checked} /> }
            edit
        </FormLabel>
        </FormGroup>
    }
    const editEntityStateChange = (act) => {
        history.push(route +'/'+ entity + '/' + act.id);
    }
    const editEntityStateEvent = (evt) => {
        setStateChangeItemId(evt.id);
    }
    const addEntityStateChange = (item) => {
        setNewItem({ status: 'Active', actionName: 'Action', dataTypeRequired: 0,dataEntry:[], entityType: entity, allowedRole: item.role.name, entityState: item.status.entityState, actionType:"State", appRoute:''})
    }
    const addEntityStateEvent = ({ stateTo, stateFrom }) => {
        const newEntity = { status: 'Active' , entityType: entity, newState: stateTo, fromState: stateFrom, targetAudience: "Client", subject: '', message: '', notificationType: 'Email', serverHandler: 'None' };
        setNewStateChangeEvent(newEntity);
    }
    const editorClosed = newItem ? () => {
        setNewItem(null);
        refreshActions();
    } : null;

    const editorStateClosed = setNewStateChangeEvent ? () => {
        setNewStateChangeEvent(null);
        setStateChangeItemId();
        refreshStatusChangeEvents();
        refreshActions();
    } : null;

    return <Container>
        <Editor route={route + '/' + entity} entity={entities.allowedAction} itemId={id} newItem={newItem} editorClosed={editorClosed}>
            
        </Editor>
        <Editor route={route + '/' + entity} entity={entities.stateChangeEvent} itemId={stateChangeItemId} newItem={newStateChangeEvent} editorClosed={editorStateClosed}>
           
        </Editor>

        <Tabs defaultActiveKey={entity} onSelect={setActiveSubTab} >
            {
                allEntities && allEntities.map(tab => {
                    return <Tab key={tab} eventKey={tab} title={tab} onSelect={() => setActiveSubTab(tab)} >
                        <Container>
                            <Row>
                                <h1>{tab}</h1>

                            </Row>
                            <Row>

                                <h2> {id}</h2>
                            </Row>
                            <Col xs={12}>
                                <Row style={{ borderBottom: '1px solid black' }}>
                                    <Col>{tab}</Col>
                                    {roles.map((rolei,i) => <Col key={i}style={{ backgroundColor: rolei.color }}>{rolei.name}</Col>)}
                                </Row>
                                {statuses && statuses.map((status,i) => <Row key={i} style={{ borderBottom: '1px solid black' }}>
                                    <Col>{status.entityState}</Col>
                                    {roles.map((role, i) => {
                                        const checked = status['canEdit' + role.name];
                                        return <Col key={i} style={{ backgroundColor: role.color }}>
                                            <Button color="success" size="sm" onClick={() => addEntityStateChange({ role, status })}active>+</Button>
                                            <Checkbox checked={checked} statusSetting={status} role={role.name}/>
                                        {actions && Array.isArray(actions) ? actions.filter(entityChanger =>
                                            entityChanger.entityState === status.entityState && entityChanger.allowedRole === role.name).map((act, i) => <Container key={i}>
                                                <Button size='sm' color="secondary" block style={{ margin: '5px' }} onClick={()=>editEntityStateChange(act)}>
                                                    <Container><Row>{act.actionName}</Row>
                                                        <Row>{'=>' + act.nextState}</Row></Container></Button>
                                            </Container>) : null}</Col>
                                    })}
                                </Row>
                                )}
                            </Col>
                        </Container>
                        <Container>
                            {loading || loadingsc || loadings ? <LoadingAnimation height={'50px'} /> :stateChanges.map(x => {
                                const validEvents = changeEvents?changeEvents.filter(z => z.fromState === x.stateFrom):[];
                                return <React.Fragment key={x.stateFrom}>
                                    {x.stateTo.map(y => {
                                        const validStateEvents = validEvents.filter(z => z.newState === y);
                                        return <Col key={y}><Row >
                                            <h1>{x.stateFrom + "->" + y}</h1>
                                            <Button color="success" size="sm" onClick={() => addEntityStateEvent({ stateFrom: x.stateFrom, stateTo: y })} active>+</Button>

                                        </Row>
                                            {validStateEvents.map((va, i) => {
                                                const email = va.notificationType === 'Email' ? '📧' : va.notificationType === 'Notification' ? '⚡︎' : va.notificationType === 'System' ?'🖥':'☏'
                                                const colorStyle =  null;
                                                return <Row key={i}>
                                                    <Button style={colorStyle} size="sm" onClick={() => editEntityStateEvent(va)} active>{email}{va.name}</Button>
                                                </Row>
                                            })}
                                        </Col>
                                    })}
                                </React.Fragment>
                            })}
                            
                        </Container>
                    </Tab>
                })

            }
        </Tabs>
        {error ? <h6>Actions did not load properly</h6> : null}
        {errors ? <h6>States did not load properly</h6> : null}
        {errorsc ? <h6>State Changes did not load properly</h6> : null}
    </Container>

}

export default ManageEntities;